<script lang="ts">
    import { getDBEntry } from "../../api"
    import { spaLink } from "../actions"
    import { navigationCache } from "../store"
    let navigationEntry: NavigationEntry = { elements: [] }

    function elementsToCache(elements: NavigationElement[]) {
        elements.forEach((el) => {
            if (!el.external) {
                if (!$navigationCache[el.page]) {
                    // only first hit to cache
                    $navigationCache[el.page] = el
                }
            }
        })
    }

    getDBEntry("navigation", {
        tree: 1,
    }).then((nav) => {
        // @ts-ignore
        navigationEntry = nav || { elements: [] }
        elementsToCache(nav?.elements || [])
    })
</script>

<footer class="paddingExtended">
    <div class="wrapper-footer">
        <div class="left">
            <div class="country">
                <h5>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                            d="M7.97499 0.5C4.69999 0.5 1.92499 2.6 0.899994 5.5H15.05C14.025 2.6 11.25 0.5 7.97499 0.5Z"
                            fill="#3E4347"
                        ></path>
                        <path
                            d="M7.97499 15.5C11.25 15.5 14.025 13.425 15.05 10.5H0.899994C1.92499 13.425 4.69999 15.5 7.97499 15.5Z"
                            fill="#FFE62E"
                        ></path>
                        <path
                            d="M0.900006 5.5C0.625006 6.275 0.475006 7.125 0.475006 8C0.475006 8.875 0.625006 9.725 0.900006 10.5H15.05C15.325 9.725 15.475 8.875 15.475 8C15.475 7.125 15.325 6.275 15.05 5.5H0.900006Z"
                            fill="#ED4C5C"
                        ></path>
                    </svg> Deutschland
                </h5>
                <div class="infos">
                    <address class="address">
                        <div>rechTEC Rechtsanwälte</div>
                        <div>Flughafenstraße 12</div>
                        <div>99092 Erfurt</div>
                    </address>
                    <div class="contact">
                        <div>Telefon: <a href="tel:+4936178929865">0361 - 789 298 65</a></div>
                        <div>Telefax: <a href="tel:+4936178929866">0361-789 298 66</a></div>
                        <div>Email: <a href="mailto:kanzlei@rechtec.de"> kanzlei[at]rechtec.de </a></div>
                    </div>
                </div>
            </div>
            <div class="country">
                <h5>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                            d="M8 0.5C4.725 0.5 1.95 2.6 0.925 5.5H15.075C14.05 2.6 11.275 0.5 8 0.5ZM8 15.5C11.275 15.5 14.05 13.425 15.075 10.5H0.925C1.95 13.425 4.725 15.5 8 15.5Z"
                            fill="#ED4C5C"
                        ></path>
                        <path
                            d="M0.925 5.5C0.65 6.275 0.5 7.125 0.5 8C0.5 8.875 0.65 9.725 0.925 10.5H15.075C15.35 9.725 15.5 8.875 15.5 8C15.5 7.125 15.35 6.275 15.075 5.5H0.925Z"
                            fill="white"
                        ></path>
                    </svg> Österreich
                </h5>
                <div class="infos">
                    <address class="address">
                        <div>rechTEC Rechtsanwälte</div>
                        <div>Gütlestraße 7a</div>
                        <div>6850 Dornbirn</div>
                    </address>
                    <div class="contact">
                        <div>Telefon: <a href="tel:+435572430946">+43 (0)5572 430946</a></div>
                        <div>Telefax: <a href="tel:+43557243094615">+43 (0)5572 430946-15</a></div>
                        <div>Email: <a href="mailto:kanzlei@rechtec.at"> kanzlei[at]rechtec.at </a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div>
                <h5>Service</h5>
                <ul>
                    {#each navigationEntry?.elements || [] as element}
                        {#if element}
                            <li>
                                <a href="{element.page}" use:spaLink>{element.name}</a>
                            </li>
                        {/if}
                    {/each}
                </ul>
            </div>
        </div>
    </div>
</footer>

<style lang="less">
    @import "../../css/variables.less";
    footer {
        background-color: var(--white-100);
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 120px 0px;
        margin-top: -48px;
        .wrapper-footer {
            margin: 0px var(--horizontal-default-margin);
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: var(--default-gap);
            max-width: var(--normal-max-width);
            width: 100%;
            @media @mobile {
                flex-direction: column;
                align-items: flex-start;
            }
            .left,
            .right {
                a {
                    color: var(--grey-100);
                    text-decoration: none;
                }

                display: flex;
                gap: var(--default-gap);
                align-items: flex-start;
                @media @mobile {
                    flex-direction: column;
                    align-items: flex-start;
                }
                & > div,
                address {
                    font-style: normal;
                    color: var(--grey-100);
                    h5 {
                        font-family: Gudea;
                        font-size: 0.9rem;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 140%;
                        color: var(--blue-100);
                        margin: 0px;
                        margin-bottom: 12px;
                    }
                }
            }
            .left {
                gap: var(--default-gap);
                display: flex;
                @media @mobile {
                    width: 100%;
                }
                .country {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    margin-bottom: 24px;
                    @media @mobile {
                        width: 100%;
                    }
                    h5 {
                        border-bottom: 1px solid var(--blue-100);
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        padding-bottom: 6px;
                        font-family: Gudea;
                        font-size: 18px;
                        font-weight: 700;
                        margin: 0px;
                    }
                    .infos {
                        display: flex;
                        gap: 24px;
                        @media @mobile {
                            flex-direction: column;
                            align-items: flex-start;
                        }
                    }
                }
            }
            .right {
                h5 {
                    text-align: end;
                    @media @mobile {
                        text-align: start;
                    }
                }
                ul {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    margin-top: 24px;

                    li {
                        display: flex;
                        justify-content: flex-end;
                        @media @mobile {
                            justify-content: flex-start;
                        }
                    }
                }
            }
        }
    }
</style>
